import type { FC, ReactNode } from 'react';

export type StepProps = {
  title: string;
  children: ReactNode;
  nextLabel?: string;
  showClose?: boolean;
};

export const Step: FC<StepProps> = () => null;
